import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import * as R from "ramda";
import { Link } from 'react-router-dom';
import * as Loadings from '../../../../constants/loadings/service';

import Emptylustration from '../../../../assets/images/svg/057-contract-1.svg';
// import Emptylustration from './../../../../assets/images/svg/047-ticket.svg';

import { DateWithModal } from '../../../../_common/dateWithModal';
import { ServiceTableFilter } from './filter';
import { ServiceTableNav } from './nav';
import { ServiceTableRow } from './row';
import { AssuranceOptionsBO, AuxiliarOptions, CommonServices, ConnectionTypes, FrenchTypes, OtherService, PersonalServices } from '../../../../constants/utils/connectionTypes';



export const ServiceTable = ({ configState, setSelectedService, setPageSearch, pageSearch, routerQuery, allServices }) => {

    const [servicesToDisplay, setServicesToDisplay] = useState(configState.services ? configState.services : []);
    const [serviceType, setServiceType] = useState(allServices.find(s => s.connectionType === configState.serviceType));
    const [lifeEvent, setLifeevent] = useState(configState.lifeEvent || "Death");

    useEffect(() => {

        setServiceType(allServices.find(s => s.connectionType === configState.serviceType));

    }, [configState]);

    const [filters, setFilters] = useState({
        order: {
            column: "name",
            asc: true
        },
        status: undefined,
        date: {
            startDate: undefined,
            endDate: undefined
        },
        search: ""
    });

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (!R.isNil(configState.services)) {
            let temp = configState.services;


            if (!R.isNil(filters.status)) {
                //  temp = temp.filter(user => user.status === filters.status);
            }


            // if (filters.order.asc) {

            //     temp = R.sort(R.ascend(R.prop(filters.order.column)), temp);

            // } else {

            //     temp = R.sort(R.descend(R.prop(filters.order.column)), temp);

            // }


            // if (!R.isEmpty(filters.search)) {
            //     temp = temp.filter(service => service.organizationName?.toLowerCase().includes(filters.search.toLowerCase()) || service.name?.toLowerCase().includes(filters.search.toLowerCase()));
            // }




            setServicesToDisplay(temp);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, configState.services]);


    return (
			<div className="container-fluid h-inherit flex-column">
				<ServiceTableFilter filters={filters} setFilters={setFilters} setPageSearch={setPageSearch} pageSearch={pageSearch} configState={configState} serviceType={serviceType} lifeEvent={lifeEvent} routerQuery={routerQuery} allServices={allServices} />
				{R.isEmpty(servicesToDisplay) ? (
					<section className="block text-center m-auto py-xs">
						<img className="img-fluid img-contain container-paper mx-auto mt-auto mb-3" src={Emptylustration} width={70} alt="Assist@" />
						<div className="block text-center container-narrow mx-auto mb-auto">
							<h1 className="h1 font-weight-semi ls-n2 lh-1">Trouvez un service.</h1>
							<p className="fs-aux o-80 mb-0">Veuillez sélectionner ci-dessus un type de service pour commencer.</p>
						</div>
					</section>
				) : (
					<>
						{configState.isLoading.includes(Loadings.FETCHING_SERVICES) ? (
							<div className="d-flex flex-column justify-content-center align-items-center h-100">
								<div className="spinner-border spinner-border-sm text-primary ml-1" role="status">
									<span className="sr-only">Loading...</span>
								</div>
							</div>
						) : (
							<section className="block h-inherit">
								<ServiceTableNav filters={filters} setFilters={setFilters} routerQuery={routerQuery} configState={configState} />
								{servicesToDisplay.map((service) => {
									return <ServiceTableRow key={service.id} serviceType={serviceType} organizationName={service.organizationName} name={service.name} address={service.address} urls={service.urls} setSelectedService={setSelectedService} service={service} />;
								})}
							</section>
						)}
					</>
				)}
			</div>
		);
};